import hljs from 'highlight.js'
import Quill from 'quill'

const Block = Quill.import('formats/code-block')
class HighLightedBlock extends Block {
  replaceWith (block) {
    this.domNode.textContent = this.domNode.textContent
    this.attach()
    super.replaceWith(block)
  }

  highlight (highlight) {
    let text = this.domNode.textContent
    if (this.cachedText !== text) {
      if (text.trim().length > 0 || this.cachedText == null) {
        this.domNode.innerHTML = highlight(text)
        this.domNode.normalize()
        this.attach()
      }
      this.cachedText = text
    }
  }
}
HighLightedBlock.blotName = 'block'
HighLightedBlock.className = 'ql-syntax'

class HighLightedBlockModule {
  constructor (quill, options) {
    Quill.register(HighLightedBlock)
    if (typeof options.highlight === 'undefined') {
      if (typeof options.languages === 'undefined') {
        options.highlight = text => hljs.highlightAuto(text).value
      } else if (Array.isArray(options.languages)) {
        options.highlight = text => hljs.highlightAuto(text, options.languages).value
      } else {
        options.highlight = text => hljs.highlight(options.languages, text)
      }
    }
    if (typeof options.interval === 'undefined') {
      options.interval = 1000
    }
    this.quill = quill
    this.options = options
    let timer = null
    this.quill.on(Quill.events.SCROLL_OPTIMIZE, () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.highlight()
        timer = null
      }, this.options.interval)
    })
    this.highlight()
  }

  highlight () {
    if (this.quill.selection.composing) return
    this.quill.update(Quill.sources.USER)
    let range = this.quill.getSelection()
    this.quill.scroll.descendants(HighLightedBlock).forEach(code => {
      code.highlight(this.options.highlight)
    })
    this.quill.update(Quill.sources.SILENT)
    if (range != null) {
      this.quill.setSelection(range, Quill.sources.SILENT)
    }
  }
}

export default HighLightedBlockModule



// WEBPACK FOOTER //
// ./src/extra/HighLightedBlockModule.js